import type { SignWord } from "../components/SignPlayer";
import { apiFetch } from "./api-client";

export type SignWordCandidate = {
  code: string;
  title: string;
  ruby: string;
  /** 同じ見出しで動画が複数あるときの連番（1始まり）。1件だけなら null */
  variant: number | null;
};

export type SignWordDetail = {
  code: string;
  title: string;
  ruby: string;
  words: SignWord[];
};

/** 手話単語の候補を検索する（読みの前方一致 → 見出しの部分一致） */
export const fetchSignWordCandidates = (
  q: string,
): Promise<SignWordCandidate[]> =>
  apiFetch<SignWordCandidate[]>(
    `/sign-words/search?q=${encodeURIComponent(q)}`,
  );

/** code 1件分の手話動画を取得する */
export const fetchSignWord = (code: string): Promise<SignWordDetail> =>
  apiFetch<SignWordDetail>(`/sign-words/${encodeURIComponent(code)}`);
